module.exports = __webpack_public_path__ + "5e3baf6fc98258473297622dbed851ea.png";